import {mapGetters} from 'vuex';
import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';
import mvtWelcome from '@/common/components/mvtwelcome/mvt-welcome.vue';


export default {
    name: 'ownerWelcome',
    inject: ['$eventBus'],
    components: {
        mvtInputGeo,
        mvtWelcome
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb'])
    },
    data: function() {
            return {
                geoInfo: {
                    text: '',
                    geo: null
                }
            }
    },
    methods: {
        resetAddressInput() {
            this.$refs.addressInput.reset();
        }
    },
    watch:{
        geoInfo(newVal){
            if(newVal){
                this.$eventBus.$emit('eventbus-claimed-home', newVal);
            }
        }
    }
}
